import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import PropTypes from 'prop-types';
import { c as classNamePropTypes } from './classNames-1ed461aa.js';
import { m as marginPropTypes } from './spacing-0f39ba4a.js';
import { S as SvgIcon } from './SvgIcon-11e6ad98.js';

function IconMessageDots(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m9.745 18.747.326-.322.454.07a9.67 9.67 0 0 0 1.475.113c4.544 0 8.182-3.115 8.182-6.9 0-3.783-3.638-6.898-8.182-6.898-4.544 0-8.182 3.115-8.182 6.899 0 2.135 1.166 4.139 3.174 5.452l.537.351-.153.62c-.174.705-.497 1.39-.965 2.057 1.286-.031 2.39-.51 3.334-1.442zM2 11.709C2 6.86 6.508 3 12 3s10 3.86 10 8.709-4.507 8.709-10 8.709c-.439 0-.876-.025-1.31-.075-1.483 1.299-3.296 1.842-5.343 1.602-1.084-.128-1.588-1.408-.87-2.23.428-.488.74-.97.942-1.447C3.264 16.63 2 14.256 2 11.708z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 10.5a1.333 1.333 0 1 1 0 2.667 1.333 1.333 0 0 1 0-2.667zm4.667 0a1.333 1.333 0 1 1 0 2.667 1.333 1.333 0 0 1 0-2.667zm-9.334 0a1.333 1.333 0 1 1 0 2.667 1.333 1.333 0 0 1 0-2.667z"
  }));
}
IconMessageDots.propTypes = {
  /** size of icon */
  size: PropTypes.oneOf(['sm', 'smd', 'md', 'mlg', 'lg', 'none']),
  /** CSS class to use, if any */
  className: classNamePropTypes,
  /** color, if not inheriting from parent's text color */
  color: PropTypes.oneOf(['ink', 'blurple', 'asphalt', 'lava', 'emerald', 'white']),
  /** margin for icon, if any */
  margin: marginPropTypes
};
IconMessageDots.defaultProps = {
  size: 'md',
  className: '',
  margin: null,
  color: null
};

export { IconMessageDots as default };
